import { LayoutCards } from '@flatsy/core/Layout/Cards'
import React from 'react'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { Header1 } from '@flatsy/core/MaterialUi/Typo'
import { useStyles } from './Style'
import Form from './Form'

const InformationForm: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  return (
    <LayoutCards strongShadow className={classes.cards}>
      <Header1 className={classes.cardsHeader}>Informations - de nom</Header1>
      <div className={classes.container}>
        <div className={classes.illustrationContainer}>
          <img
            src={FlatsyTheme.image.professional_card}
            alt="professional cards illustration"
            className={classes.illustration}
          />
        </div>
        <Form />
      </div>
    </LayoutCards>
  )
}

export default InformationForm
